const mainTheme = {
  // Discriminator for components that must branch on mode (e.g. the themed
  // Shimmer) rather than read a token. darkTheme overrides this to true.
  isDark: false,
  colors: {
    // ── Semantic tokens ──────────────────────────────────────────────────────
    // Use these in new and converted components. Named for what they represent,
    // not what they look like, so dark mode just swaps the values.
    backgroundApp: '#f5f5f5', // page-level background behind panels
    surface: 'white', // primary content background
    surfaceElevated: 'white', // floating surfaces: modals, menus (light = same as surface)
    surfaceInput: 'white', // input field fill (light = same as surface)
    surfaceSecondary: '#F5F5F5', // secondary background, inputs, hover fills
    surfaceTertiary: '#f1f1f1', // tertiary background
    surfaceHover: 'rgba(68, 68, 68, 0.05)', // hover overlay on surfaces
    textStrong: '#000000', // strongest text (month view day numbers)
    textSecondary: '#9E9E9E', // secondary / muted text
    textTertiary: '#BDBDBD',
    // Table-cell placeholders (empty reps / weight / % cells). Same value as textTertiary
    // today; the design wants #929292 -- swap it in buildTheme once the designer signs off.
    textPlaceholder: '#BDBDBD', // placeholder / disabled text
    textMuted: '#666666', // mid-weight muted text
    textDark: '#333333', // darker text / dark ui elements
    borderLight: '#EEEEEE', // standard light divider / border
    borderMedium: '#E0E0E0', // mid-weight border (darker than borderLight)
    borderStrong: '#EEEEEE', // card dividers that must read on dark; light = borderLight
    shadowCard: '0px 1px 3px 0px rgba(48, 49, 51, 0.3)', // day cards, week nav
    shadowPanel: '0px 4px 8px 0px #3031331A', // sidebars, footers, menus
    textDisabled: '#D5D5D5', // disabled field text
    surfaceHoverStrong: '#F0F0F0', // solid hover fill (opaque, unlike surfaceHover)
    // Rows a pending undo will revert (History sidebar); warmup-red tint.
    surfaceSelectedDestructive: 'rgba(214, 69, 65, 0.12)',
    borderButton: '#EEEEEE', // button border (in light mode same as borderLight)
    buttonBackground: 'transparent', // header button resting background
    buttonPrimaryBg: '#444444',
    buttonPrimaryBgHover: '#333333', // primary CTA on hover
    buttonDisabledBg: '#E0E0E0', // primary CTA when disabled
    buttonDisabledText: '#757575',
    buttonPanelBg: '#444444', // full-width action bar pinned to a panel footer
    link: '#5b86e5',
    // Hover / focus indicator for interactive elements: input focus borders, focus rings,
    // icon and text hover. Shared by both modes; the designer's info blue.
    hover: '#77A7FF',
    iconActive: '#444444', // selected icon in a nav rail (app default; Build overrides)
    scrollbarThumb: 'rgba(0, 0, 0, 0.2)', // scrollbar thumb
    overlayMedium: 'rgba(0, 0, 0, 0.5)', // modal/dropdown backdrop
    overlayStrong: 'rgba(0, 0, 0, 0.7)', // strong overlay
    // ── Legacy indexed tokens (kept for backward compat) ──────────────────
    text: '#444444',
    lightText: [
      '#979797',
      '#686868',
      'rgba(68, 68, 68, 0.35)',
    ],
    background: [
      'white',
      'white',
      'white',
      'rgba(68, 68, 68, 0.15)',
      '#f5f5f5',
      '#f1f1f1',
    ],
    border: '#e4e7e7',
    buttonBorder: [
      '#979797',
      '#ACACAC',
    ],
    focus: [
      '#0dcc8a',
      '#ff6600',
    ],
    overlay: 'rgba(216, 216, 216, 0.5)',
    noBorderForm: 'hsl(0,0%,80%)',
    noBorderColor: '#979797',
    iconBorder: '#444444',
    overflowGradient: 'linear-gradient(to right,rgba(255,255,255,0),rgba(255,255,255,1))',
    gradient: 'linear-gradient(-20deg, #fc6076 0%, #ff9a44 100%)',
    gradientOverlay: 'linear-gradient(-20deg, rgba(252, 96, 118, 0.5) 0%, rgba(255, 154, 68, .5) 100%)',
    darkBlue: '#1c212f',
    lightBlue: '#3fbfe1',
    blue: '#5b86e5',
    green: '#0dcc8a',
    red: '#ff0024',
    redBlend: '#D67F5A',
    orange: '#ff6600',
    yellow: '#FFCB47',
    // Inline warning banners (copy modal, offset-calendar notice).
    warningSurface: '#FFFBEB',
    warningBorder: '#FFCB47',
    warningText: '#333333',
    textError: '#CC0404', // inline validation text, 6.6:1 on white
    tooltipSurface: 'white', // TBTooltip bubble; same as surface in light
    yellowBlend: '#A1D174',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    black: '#444445',
    darkGray: '#616161',
    gymStudio: '#81A1D3',
    white: '#FFFFFF',
  },
  headerFontSizes: [
    '24pt',
    '20pt',
    '18pt',
    '16pt',
  ],
  textFontSizes: [
    '10pt',
    '12pt',
    '14pt',
    '16pt',
  ],
};

// const theme = {
//   colorAccent: skin && skin.accent,
//   colorPrimary: skin && skin.primary,
//   colorSecondary: skin && skin.secondary,
//   isAccentDarkTheme: skin && skin.accentDarkTheme,
//   isDarkTheme: skin && skin.darkTheme,
//   isPrimaryDarkTheme: skin && skin.darknessMode,
//   isSecondaryDarkTheme: skin && skin.secondaryDarkTheme,
//   // ...defaultTheme,
//   ...mainTheme,
// };

export default mainTheme;

// export const defaultTheme = {
// };

// export const lightTheme = {
//   colors: {
//     text: '#444444',
//     lightText: [
//       '#979797',
//       '#686868',
//       'rgba(68, 68, 68, 0.35)',
//     ],
//     background: [
//       'white',
//       'white',
//       'white',
//     ],
//     border: '#e4e7e7',
//     buttonBorder: [
//       '#979797',
//       '#ACACAC',
//     ],
//     focus: [
//       '#0dcc8a',
//       '#ff6600',
//     ],
//     overlay: 'rgba(216, 216, 216, 0.5)',
//     noBorderForm: 'hsl(0,0%,80%)',
//     noBorderColor: '#979797',
//     iconBorder: '#444444',
//     overflowGradient: 'linear-gradient(to right,rgba(255,255,255,0),rgba(255,255,255,1))',
//     gradient: 'linear-gradient(-20deg, #fc6076 0%, #ff9a44 100%)',
//     gradientOverlay: 'linear-gradient(-20deg, rgba(252, 96, 118, 0.5) 0%, rgba(255, 154, 68, .5) 100%)',
//     darkBlue: '#1c212f',
//   },
// };

/**
 * Compose theme layers, innermost-last.
 *
 * `colors` has to be merged one level down rather than shallow-spread: spreading
 * whole layers would let the last one's `colors` replace the map instead of
 * merging into it, dropping every key it does not itself declare.
 *
 * Build's precedence is mainTheme -> buildTheme -> darkTheme, so the light
 * high-contrast values override the app defaults and a dark value overrides
 * both. See Calendar.js.
 */
export const mergeThemes = (...layers) => layers.reduce((merged, layer) => ({
  ...merged,
  ...layer,
  colors: { ...merged.colors, ...layer.colors },
}), {});

/**
 * Light-mode high-contrast overrides for the Build (calendar) module — the
 * Week View "Updated UI" redesign, which applies to day, week and month views.
 *
 * Scoped rather than folded into mainTheme on purpose: `colors.text` alone has
 * ~110 call sites in 16 other modules, and none of them are in this redesign's
 * scope. Calendar.js merges this over mainTheme (and under darkTheme) so the
 * new values stop at Build's boundary.
 *
 * Only `colors` is read from here; see mergeThemes above and Calendar.js.
 *
 * Values are read from the designer's Week View file via get_design_context,
 * not sampled. The redesign is five colours in total — #1A1A1A, #929292,
 * #1787FB, #D6D6D6 and white — so the current five-step grey ladder collapses
 * to two. Tokens NOT listed here (textTertiary, textMuted, textDark, textStrong)
 * are left alone on purpose: Week View shows no disabled states or modals, so
 * it offers no evidence about them, and textTertiary's dark value fixes a real
 * WCAG AA failure that a blind collapse would undo.
 */
export const buildTheme = {
  colors: {
    text: '#1A1A1A', // primary text and numbers
    textSecondary: '#929292',
    textMuted: '#616161', // stats labels; the design's mid grey, 5.9:1 on white
    borderLight: '#D6D6D6', // the design has one hairline
    borderMedium: '#D6D6D6',
    borderButton: '#D6D6D6', // header controls (Today, view picker, settings)
    buttonPrimaryBg: '#1A1A1A', // today pill, Add Exercise chip
    link: '#1787FB', // "Edit" links, always bold
    /* Not in the Figma; the active rail icon is Elvis's addition. The brand
     * orange #ff6600 sits at 2.94:1 on white, just under WCAG 1.4.11's 3:1 for
     * UI icons — the wrong thing to ship in a high-contrast pass. #E55C00 is the
     * least darkening that clears it, and holds on every dark surface too
     * (4.86:1 on #1A1A1A), so one value serves both modes. */
    iconActive: '#E55C00',
  },
};

/** The one border ink dark mode draws: dividers, button borders and the rail
 * edge all read it, so it lives in one place rather than four literals. */
const DARK_HAIRLINE = '#333333';

export const darkTheme = {
  isDark: true,
  colors: {
    /* A pure override layer — no `...mainTheme.colors` spread here. Calendar's
     * mergeThemes supplies mainTheme as the base, so a key absent below simply
     * inherits its light value instead of rendering `undefined`.
     *
     * Do NOT reintroduce the spread. It would carry a light value for every key
     * this object does not explicitly declare, and those would then win over
     * buildTheme (which sits between mainTheme and this layer), silently
     * reverting the Build high-contrast values in dark mode. */
    // ── Semantic tokens (dark mode values) ──────────────────────────────────
    backgroundApp: '#000000', // page-level background behind panels
    surface: '#1A1A1A', // panels (Figma theme/bg/surface)
    surfaceElevated: 'rgb(36, 36, 36)', // modals/menus — no Figma spec, keeps modals above panels
    surfaceInput: '#262626', // fields (Figma theme/input/background); its #333 border separates it
    surfaceSecondary: '#262626', // raised detail rows (Figma)
    surfaceTertiary: 'rgb(50, 50, 50)',
    surfaceHover: 'rgba(255, 255, 255, 0.06)',
    textStrong: '#FFFFFF', // Figma theme/fg/on-dark — headings, short labels
    textSecondary: '#9E9E9E', // Figma theme/fg/subtle (same in both modes)
    textTertiary: '#BDBDBD', // Figma theme/fg/disabled (was 38% white — failed AA)
    textMuted: 'rgba(255, 255, 255, 0.70)',
    textDark: '#FFFFFF', // Figma theme/fg/on-dark
    borderLight: DARK_HAIRLINE,
    borderMedium: DARK_HAIRLINE, // same as borderLight in dark: one border weight
    borderStrong: '#454545', // one step brighter than borderLight so card dividers read
    /* A dark drop shadow disappears on dark surfaces; a hairline ring outlines
       the card instead. */
    shadowCard: '0 0 0 1px rgba(255, 255, 255, 0.12)',
    /* A dark drop shadow is invisible on dark surfaces; the rail's edge is a
       1px rule in the same ink as the header's bottom border (borderLight). */
    shadowPanel: `1px 0 0 0 ${DARK_HAIRLINE}`,
    textDisabled: '#BDBDBD', // Figma theme/fg/disabled
    /* One step above the raised tier it sits on: a hover fill at #262626 was
     * invisible inside a #262626 stepper or on a selected row. 1.15:1 against
     * its container, matching the system's other layer steps. */
    surfaceHoverStrong: '#303030',
    // The light 12% tint all but vanishes on #1A1A1A; double it so the selection reads.
    surfaceSelectedDestructive: 'rgba(214, 69, 65, 0.24)',
    borderButton: DARK_HAIRLINE,
    buttonBackground: '#262626',
    /* Same ink as light mode. A filled CTA has to out-emphasise every surface,
     * not sit on the next layer up — #262626 put modal CTAs at 1.03:1 against
     * their own modal. #444444 reads as a button on every dark surface
     * (1.59:1 vs a modal) with a 9.7:1 white label, and keeps buttonPrimaryBg
     * distinct from buttonBackground the way light mode does. */
    buttonPrimaryBg: '#444444',
    buttonPrimaryBgHover: 'rgb(62, 62, 68)',
    buttonDisabledBg: '#262626',
    buttonDisabledText: '#BDBDBD',
    /* Opaque so a warning can float over content (History's Undo warning sits
     * over the card list) without it showing through. Equivalent to a 10% /
     * 55% amber tint on the #1A1A1A panel. */
    warningSurface: '#312C1F',
    warningBorder: '#987B33',
    warningText: 'rgba(255, 255, 255, 0.8)',
    textError: '#FF6B6B', // inline validation text; #CC0404 sinks into dark surfaces
    tooltipSurface: '#444444', // TBTooltip bubble; surface-on-surface vanished in the sidebars
    /* Figma keeps the sidebar's footer bar at the raised tier rather than
     * giving it CTA emphasis (his Exercise Database button is #262626).
     * It is full-width on a panel, so it does not need to shout. */
    buttonPanelBg: '#262626',
    /* Build's light link #1787FB only reaches 4.36:1 on a #242424 modal, and no
     * single blue clears AA on both white and dark surfaces. This is the
     * designer's own shared info blue (7.26:1 on #1A1A1A) and already the
     * app's FOCUS_BLUE, so links and focus rings agree in dark mode. */
    link: '#77A7FF',
    scrollbarThumb: 'rgba(255, 255, 255, 0.18)',
    overlayMedium: 'rgba(0, 0, 0, 0.65)',
    overlayStrong: 'rgba(0, 0, 0, 0.80)',
    // ── Legacy indexed tokens ────────────────────────────────────────────────
    /* Deliberate deviation from Figma, which specs #FFFFFF for all foreground:
     * body copy and set data stay at 80% (#D1D1D1, 11.4:1). Pure white on
     * near-black halates for readers with astigmatism; textStrong/textDark
     * carry #FFFFFF for headings and short labels instead. */
    text: 'rgba(255, 255, 255, 0.80)',
    lightText: [
      'rgba(255, 255, 255, 0.75)',
      'rgba(255, 255, 255, 0.65)',
      'rgba(255, 255, 255, 0.55)',
    ],
    background: [
      '#1A1A1A',
      'rgb(40, 40, 40)',
      'rgb(55, 55, 55)',
    ],
    border: 'rgb(100, 100, 100)',
    buttonBorder: [
      'rgb(65, 65, 65)',
      'rgb(65, 65, 65)',
    ],
    focus: [
      '#0ab3cd',
      '#ff6600',
    ],
    overlay: 'rgba(30, 30, 30, 0.6)',
    noBorderForm: 'rgb(95, 95, 95)',
    noBorderColor: 'rgba(30, 30, 30, 0.6)',
    iconBorder: 'rgba(65, 65, 65)',
    overflowGradient: 'linear-gradient(to right,rgba(36,36,36,0),rgba(36,36,36,1))',
    gradient: 'linear-gradient(-20deg, #fc6076 0%, #ff9a44 100%)',
    gradientOverlay: 'linear-gradient(-20deg, rgba(252, 96, 118, 0.5) 0%, rgba(255, 154, 68, .5) 100%)',
    darkBlue: '#1c212f',
  },
};

// const skin = {
//   accent: '#006a65',
//   accentDarkTheme: false,
//   background: '',
//   darkTheme: false,
//   darknessMode: true,
//   logo: 'https://s3.amazonaws.com/teambuildr-staging-assets/logos/-1548780431.png',
//   primary: '#472233',
//   secondary: '#ffffff',
//   secondaryDarkTheme: true,
//   exerciseIconDarkTheme: false,
//   exerciseIconInverted: false,
//   exerciseStatusDarkTheme: false,
//   actionColors: {
//     add: '#2ecc71',
//     edit: '#3498db',
//     view: '#3498db',
//     complete: '#27ae60',
//   },
//   exerciseColors: {
//     note: '#F9BF3B',
//     warmup: '#D64541',
//     cooldown: '#81CFE0',
//     lift: '#6C7A89',
//     tag: '#6C7A89',
//     circuit: '#F89406',
//     cardio: '#59ABE3',
//     health: '#F64747',
//     science: '#9b59b6',
//     video: '#e74c3c',
//     rest: '#34495e',
//     break: '#34495e',
//     progression: '#446CB3',
//   },
//   supersetColors: {
//     A: '#00d68b',
//     B: '#0ab3cd',
//     C: '#f36dab',
//     D: '#f3ea6d',
//     E: '#f3a96d',
//     F: '#f3716d',
//     G: '#6de1f3',
//     H: '#c389f5',
//     I: '#f5898b',
//     J: '#00d68b',
//     K: '#0ab3cd',
//     L: '#f36dab',
//     M: '#f3ea6d',
//     N: '#f3a96d',
//     O: '#f3716d',
//     P: '#6de1f3',
//     Q: '#c389f5',
//     R: '#f5898b',
//     S: '#00d68b',
//     T: '#0ab3cd',
//     U: '#f36dab',
//     V: '#f3ea6d',
//     W: '#f3a96d',
//     X: '#f3716d',
//     Y: '#6de1f3',
//     Z: '#c389f5',
//   },
//   entryColors: {
//     save: '#2dcc70',
//     journal: '#f9bf3a',
//     video: '#d8534f',
//     history: '#03c44f',
//     document: '#a5a5a5',
//     close: '#ff5844',
//     optOut: '#f9bf3a',
//   },
// };
